import { render, staticRenderFns } from "./teamsalarychange.vue?vue&type=template&id=460e94e6&scoped=true&"
import script from "./teamsalarychange.vue?vue&type=script&lang=js&"
export * from "./teamsalarychange.vue?vue&type=script&lang=js&"
import style0 from "./teamsalarychange.vue?vue&type=style&index=0&id=460e94e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460e94e6",
  null
  
)

export default component.exports